var React =              require("react");
var ApplicationContext = require("./../../config/ApplicationContext.js");
var Utilities =          require("./../../util/Utilities.js");
const {  canUseDOM  } = require('fbjs/lib/ExecutionEnvironment');

var SearchBoxOption =    require("./SearchBoxOption.jsx");

class SearchBox extends React.Component {

    constructor(){
        super();

        this.state = {filters: []}

        this.getId = this.handleId();
        this.functionSelected = "";
        this.setOne = this.handleSearchOne();
        this.onSearch = this.onSearch.bind(this);
        this.onAddItem = this.onAddItem.bind(this);
        this.onRemoveItem = this.onRemoveItem.bind(this);
        this.onSearchPackages = this.onSearchPackages.bind(this);
        this.onSearch3DModels = this.onSearch3DModels.bind(this);
        this.onSearchLibraries = this.onSearchLibraries.bind(this);
        this.onSearchPublicPackages = this.onSearchPublicPackages.bind(this);
        this.onSearchTrash = this.onSearchTrash.bind(this);
    }

    componentDidMount(){
       // if we want to turn back on a filter by default
       //if(this.props.isExplore) this.clearAndAddDefaultVal();
       this.setState({ filters: [] });
    }


    componentWillReceiveProps(nextProps){
        //query comes from general search (next to the "What's new")
        const { setSearchValue } = nextProps

        // if(!setSearchValue && this.props.isExplore && this.props.type != nextProps.type && nextProps.type == "packages"){
        //   this.clearAndAddDefaultVal();
        // } else if(setSearchValue && this.props.isExplore && this.props.type != nextProps.type && nextProps.type == "packages"){
        //   // if search value reset filters
        //   this.clearAndAddFirstEmpty();
        // }

        if(setSearchValue !== undefined){
            this.query.value = setSearchValue;
        }
    }

    clearAndAddDefaultVal(){
        this.setState({ filters: [
          {id: this.getId.add(), defaultVal: true},
      //    {id: this.getId.add()},
        ] });
    }

    clearAndAddFirstEmpty(){
        this.setState({ filters: [
      //    {id: this.getId.add()}
        ] });
    }

    onAddItem(){
        this.setState({ filters: [ ...this.state.filters, {id: this.getId.add()} ]});
    }

    onRemoveItem(id){
        if(this.props.onRemove){ this.props.onRemove() }
        this.setState({ filters: this.state.filters.filter(item => item.id !== id)});
        setTimeout(() => this.functionSelected(), 0);
    }

    // explore search, onSetUrlLibraries == setValueSearch
    onSearch(){
        this.props.onSetUrlLibraries({value: this.query.value, url: `q=${Utilities.escapeSpecialCharacters(this.query.value)}`}, true);
    }
    // explore search, onSetUrlLibraries == setValueSearch
    onSearchPublicPackages(){
        this.props.onSetUrlLibraries({value: this.query.value, url: Utilities.createNonEmptyQueryString(this.query.value, this.getProperties())}, true);
    }
    // dashboard search, onSetUrlLibraries == updateDataOnceUserLogin
    onSearchLibraries(){
        this.props.onSetUrlLibraries(undefined, `/libraries?q=${Utilities.escapeSpecialCharacters(this.query.value)}`, 1, true);
    }
    // dashboard search, onSetUrlLibraries == updateDataOnceUserLogin
    onSearchPackages(){
        this.props.onSetUrlLibraries(undefined, `/packages?${Utilities.createNonEmptyQueryString(this.query.value, this.getProperties())}`, 1, true);
    }
    // dashboard search, onSetUrlLibraries == updateDataOnceUserLogin
    onSearch3DModels(){
        this.props.onSetUrlLibraries(undefined, `/3dmodels?q=${Utilities.escapeSpecialCharacters(this.query.value)}`, 1, true)
        
    }
    // dashboard search, onSetUrlLibraries == updateDataOnceUserLogin
    onSearchTrash(){
        this.props.onSetUrlLibraries(undefined, `/trash?q=${Utilities.escapeSpecialCharacters(this.query.value)}`, 1, true)
    }
    
    getProperties(){
        let item = [...document.querySelectorAll("#formPackages .searchboxOption__filter")];
        return item.reduce((accum, current) => this.getValidProperties(accum, current), {query:"", properties: new Map()})
                        .query.slice(0, -1);
    }

    getUsedPropertiesNames(){
        const selects = document.querySelectorAll("#formPackages .searchboxOption__filter");
        const usedNames = new Set();

        selects.forEach(select => {
            if (select.value && select.value !== "Select Filter") usedNames.add(select.value);
        });

        return usedNames;
    }

    getEvent(path){
        let event;
        if(/search\/(3dmodels|libraries)/gi.test(path)){
            event = this.onSearch;
        }else if(/(search\/packages|qt-search)/gi.test(path)){
            event = this.onSearchPublicPackages;
        }else if(/(\\*\/libraries)/gi.test(path)){
            event = this.onSearchLibraries
        }else if(/(\\*\/3dmodels)/gi.test(path)){
            event = this.onSearch3DModels
        }else if(/(\\*\/packages)/gi.test(path)){
            event = this.onSearchPackages
        }else if(/(\\*\/trash)/gi.test(path)){
            event = this.onSearchTrash
        }else{
            event = this.onSearch
        }
        return event;
    }

    getStructure(){
        let path = canUseDOM ? Utilities.getPath(): "", inputSearch, filters, boxOption;
        let placeholderMessaje = path.includes("search") ? "Search public content...": "Search your content..."
        let filterCondition = /(packages|qt-search)/gi.test(path);

        this.functionSelected = this.getEvent(path);
        inputSearch = <input type="text" placeholder={placeholderMessaje} ref={input => this.query = input} onInput={this.functionSelected}/>;

        filters = filterCondition ? <button className="searchbox__filter" onClick={this.onAddItem}></button>: null;

        boxOption = filterCondition && this.state.filters.length > 0 ?   <div id="formPackages">
                                            {this.state.filters.map((info, i) => <SearchBoxOption {...info}
                                                                                key={info.id}
                                                                                onAddItem={this.onAddItem}
                                                                                onSearchPackages={this.functionSelected}
                                                                                onRemoveItem={this.onRemoveItem}
                                                                                hasAdd={i == this.state.filters.length - 1}
                                                                                searchText={this.query.value}
                                                                                getUsedPropertiesNames={this.getUsedPropertiesNames}
                                                                        />)}
                                        </div> : null;

        return { inputSearch, filters, boxOption }
    }

    formatName(name){
        return name.replace(/ /g,"_").toLowerCase();
    }

    getValidProperties({properties, query}, current){
        const input = current.nextElementSibling;
        const isValidInput = !input.classList.contains("invalid") && input.value !== "" && /(INPUT|SELECT)/gi.test(input.tagName);
        if(current.value !== "Select_Filter" && isValidInput){
            const property = this.formatName(current.value);
            const value = this.formatName(input.dataset.valShadow);
            if(!properties.has(property)){
                properties.set(property, value);
                query += `properties.${property}=${value}&`;
            }
        }
        return {properties, query};
    }

    handleId(){
        let id = 0;
        return{ add(){ return ++id } }
    }

    handleSearchOne(){
        let one = true
        return {
            isOne(){
               if(one){ one = false; return true }
               return false;
            }
        }
    }

    render() {
        const { inputSearch, filters, boxOption } = this.getStructure();
        return  <div>
                    <div className={this.props.isSearchPage ? "searchbox pageSearch" : "searchbox"}>
                        <button className="searchbox__search"></button>
                        { inputSearch }
                        { filters }
                    </div>
                    { boxOption }
                </div>
    }
};

module.exports = SearchBox;
